import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Workflow } from 'app/Model/Dto/Workflow/Workflow';

@Component({
  selector: 'np-dataprocess-workflow-dialog',
  templateUrl: './dataprocess-workflow-dialog.component.html',
  styleUrl: './dataprocess-workflow-dialog.component.css'
})
export class DataprocessWorkflowDialogComponent {
  @Input() public visible: boolean = false;
  @Input() public workflow: Workflow;
  @Input() public title: string = '';

  @Output() public visibleChange = new EventEmitter<boolean>();
  @Output() public saveRequested = new EventEmitter<void>();
  @Output() public cancelRequested = new EventEmitter<void>();

  public close(): void {
    this.visibleChange.emit(false);
    this.cancelRequested.emit();
  }

  public save(): void {
    this.saveRequested.emit();
  }
}
